import { range } from '../../utils/arrays.js';
import { PAGINATION_BUTTON_SIZES } from './Pagination.constants.js';

var pagesToShow = function pagesToShow(_ref) {
  var currentPage = _ref.currentPage,
    lastPage = _ref.lastPage,
    pagesToRender = _ref.pagesToRender;
  var isEvenPagesToRender = pagesToRender % 2 === 0;
  var previousPagesToRender = isEvenPagesToRender ? pagesToRender / 2 - 1 : Math.floor(pagesToRender / 2);
  var potentialStartPage = currentPage - previousPagesToRender;
  var startPageRangeEnd = lastPage - pagesToRender + 1;
  var startPage = Math.max(1, Math.min(potentialStartPage, startPageRangeEnd));
  var endPage = Math.min(startPage + pagesToRender - 1, lastPage);
  var adjustedStartPage = Math.max(1, Math.min(startPage, startPageRangeEnd));
  return range(adjustedStartPage, endPage);
};
var getPaginationLabel = function getPaginationLabel(dataLength, itemsPerPage, activePage, labelText) {
  if (!dataLength || !itemsPerPage || !activePage) {
    return '';
  }
  var lastPageItemCount = dataLength % itemsPerPage === 0 ? itemsPerPage : dataLength % itemsPerPage;
  var lastPageUnusedItems = itemsPerPage - lastPageItemCount;
  var totalPageCount = Math.ceil(dataLength / itemsPerPage);
  var isLastPage = totalPageCount === activePage;
  var firstItem = (activePage - 1) * itemsPerPage + 1;
  var lastItem = activePage * itemsPerPage - (isLastPage ? lastPageUnusedItems : 0);
  return "".concat(firstItem, "-").concat(lastItem, " ").concat(labelText.replace('$', dataLength));
};
var getButtonBaseWidth = function getButtonBaseWidth(size, activePage) {
  switch (true) {
    case activePage < 99:
      return PAGINATION_BUTTON_SIZES[size][0];
    case activePage < 999:
      return PAGINATION_BUTTON_SIZES[size][1];
    case activePage < 9999:
      return PAGINATION_BUTTON_SIZES[size][2];
    default:
      return PAGINATION_BUTTON_SIZES[size][3];
  }
};

export { getButtonBaseWidth, getPaginationLabel, pagesToShow };
//# sourceMappingURL=Pagination.helper.js.map
